export default __webpack_public_path__ + "static/media/straightLayer.0424d588.svg";